import React from 'react';

// titles: optional { editTitle, deleteTitle } to replace the generic tooltip
// text with something page-specific (e.g. what editing/deleting actually does).
const TableActionButtons = (record, onEdit, onDelete, titles = {}) => {
  const { editTitle = 'Edit Record', deleteTitle = 'Delete Record' } = titles;
  return (
    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
      <button
        onClick={() => onEdit(record)}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          fontSize: '15px',
          padding: '4px',
          borderRadius: '4px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        title={editTitle}
      >
        ✏️
      </button>
      {onDelete && (
        <button
          onClick={() => onDelete(record)}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontSize: '15px',
            padding: '4px',
            borderRadius: '4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          title={deleteTitle}
        >
          🗑️
        </button>
      )}
    </div>
  );
};

export default TableActionButtons;
